import RewardsPage from 'screens/Rewards/Rewards';

export default RewardsPage;
